module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Elodie-meisje-letterpress-roze-3.84c19931.jpg";